import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class NumberInput extends Component {
  state = {
    invalidValue: null,
  };

  onInputChanged = val => {
    const { onChange, min, max, noDecimals, step } = this.props;
    let parsedValue = noDecimals ? Number.parseInt(val) : Number.parseFloat(val);
    if (Number.isNaN(parsedValue)) {
      this.setState({ invalidValue: val });
      onChange(null);
    } else if (typeof step === 'number' && step > 0 && Math.abs(parsedValue % step) > 1e-9 /* floating-point tolerance: 4.5 % 0.5 can produce ~1e-16 instead of 0 */) {
      this.setState({ invalidValue: val });
      onChange(null);
    } else {
      this.setState({ invalidValue: null });
      if (min !== null && !Number.isNaN(min) && min > parsedValue) parsedValue = min;
      if (max !== null && !Number.isNaN(max) && max < parsedValue) parsedValue = max;
      onChange(parsedValue);
    }
  };

  // Submit on blur
  handleBlur = () => {
    const { invalidValue } = this.state;
    const { onBlur, value, onChange } = this.props;
    if (invalidValue !== null) {
      this.setState({ invalidValue: null });
      onChange(value || 0);
    }
    onBlur();
  };

  render() {
    const { value, className, noDecimals, step, ...rest } = this.props;
    const { invalidValue } = this.state;
    const safePropValue = value == null ? '' : value;

    return (
      <input
        step={step ?? 'any'}
        {...rest}
        type="number"
        value={invalidValue == null ? safePropValue : ''}
        onChange={e => this.onInputChanged(e.target.value)}
        onBlur={this.handleBlur}
        className={classnames(className, 'form-control', {
          markedError: invalidValue !== null && invalidValue !== '',
        })}
      />
    );
  }
}
NumberInput.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  noDecimals: PropTypes.bool,
  step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

NumberInput.defaultProps = {
  value: 0,
  onBlur: () => {},
  className: '',
  min: null,
  max: null,
  noDecimals: false,
};
export default NumberInput;
